import { render, staticRenderFns } from "./project-selecor.vue?vue&type=template&id=5f396d45"
import script from "./project-selecor.vue?vue&type=script&lang=js"
export * from "./project-selecor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports